<div class="nb-theme-default">
<nb-card [status]="status" [size]="size" [accent]="accent" showh="showh">
    <!-- <div show="show" *ngIf="show"> -->
    <nb-card-header *ngIf="showh">{{ header }} </nb-card-header>
    <nb-card-body>
        <div class="content">
        <slot></slot>
        </div>
    </nb-card-body>
    <!-- </div> -->
</nb-card>
</div>